/**
 * Shared TanTable row tint for soft-deleted records. Applied via the
 * `getRowClassName` prop; the table makes such rows' cells transparent and drops
 * its own (gray) zebra class so this tint shows through. Two shades let deleted
 * rows keep zebra striping — a deeper red on the striped (even) rows.
 */
export const DELETED_ROW_CLASS =
  'bg-red-50 dark:bg-red-900/20 hover:bg-red-100 dark:hover:bg-red-900/30';
export const DELETED_ROW_CLASS_ZEBRA =
  'bg-red-100 dark:bg-red-900/40 hover:bg-red-200 dark:hover:bg-red-900/50';

/**
 * Returns the deleted-row tint when `isDeleted` (deeper shade on zebra-striped
 * rows), else an empty string. Pass the `zebra` flag from getRowClassName's meta.
 */
export const deletedRowClass = (isDeleted: boolean, zebra = false): string =>
  isDeleted ? (zebra ? DELETED_ROW_CLASS_ZEBRA : DELETED_ROW_CLASS) : '';
